export const IDLE_TIME = 300000;